module.exports = __webpack_public_path__ + "assets/img/house-broken.8e6f9158.jpg";